import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "api/api";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

function BusinessServices() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const columns = [
    { Header: "SL.NO", accessor: "sl_no", align: "left", sortable: true },
    { Header: "Title", accessor: "title", align: "left", sortable: true },
    { Header: "Status", accessor: "status", align: "left", sortable: false },
    { Header: "Date", accessor: "date", align: "left", sortable: false },
    { Header: "Action", accessor: "action", align: "left", sortable: false },
  ];

  useEffect(() => {
    api
      .get("admin/service")
      .then((res) => {
        const data = res.data;
        const _services = data.data || [];

        const formatDateTime = (dateString) => {
          if (!dateString) return "N/A";
          const date = new Date(dateString);
          return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
        };

        const formattedRows = _services.map((serv, index) => ({
          id: serv.id, // important for deletion
          sl_no: index + 1,
          title: serv.title || "N/A",
          date: formatDateTime(serv.createdAt),
          status: (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={serv.isActive ? "Active" : "Inactive"}
                color={serv.isActive ? "success" : "error"}
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ),
          action: (
            <>
              <Link
                to={`/service/${serv.id}`}
                style={{
                  color: "#1976d2",
                  textDecoration: "none",
                  marginRight: "10px",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
              >
                <EditIcon fontSize="small" />
              </Link>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDelete(serv.id);
                }}
                style={{
                  color: "#d32f2f",
                  textDecoration: "none",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
              >
                <DeleteIcon fontSize="small" />
              </a>
            </>
          ),
        }));

        setRows(formattedRows);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this service?");
    if (!confirmDelete) return;

    try {
      const response = await api.delete(`admin/service/delete/${id}`);
      const result = response.data;

      if (result.status) {
        setRows((prevRows) => prevRows.filter((row) => row.id !== id));
        alert("Service deleted successfully!");
      } else {
        throw new Error(result.message || "Failed to delete the service.");
      }
    } catch (error) {
      console.error("Error deleting service:", error);
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    Business Service List
                  </MDTypography>
                  <Link
                    to="/service/add"
                    style={{
                      color: "white",
                      textDecoration: "underline",
                      fontWeight: "bold",
                      fontSize: "0.9rem",
                    }}
                  >
                    ADD NEW
                  </Link>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                {loading ? (
                  <MDTypography px={2}>Loading...</MDTypography>
                ) : (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    entriesPerPage={true}
                    showTotalEntries={true}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BusinessServices;
